import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import RecipeView from './views/recipeview.js';
import SearchView from './views/searchview.js';
import ResultsView from './views/resultview.js';
import PaginationView from './views/paginationview.js';
import BookmarksView from './views/bookmarksview.js';
import AddRecipeView from './views/addrecipeview.js';

//import 'core-js/stable';
//import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';

const controlRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);

    if (!id) return;
    RecipeView.renderSpinner();

    //0) Update result view to markselected search result
    ResultsView.update(model.getSearchResultsPage());

    //1) Updating bookmarks view
    BookmarksView.update(model.state.bookmarks);

    //2) LOADING RECIPE
    await model.loadRecipe(id);

    //3) RENDERING  THE RECIPE
    RecipeView.render(model.state.recipe);

  } catch (err) {
    RecipeView.renderError();
    console.error(err)
  };

};

const controlSearchResult = async function () {
  try {
    ResultsView.renderSpinner();

    // 1) Get search query
    const query = SearchView.getQuery();
    if (!query) return;

    //2) Load search rescults
    await model.loadSearchResult(query);

    //3) Render results
    ResultsView.render(model.getSearchResultsPage());

    //4) Render initial pagination buttons
    PaginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controlPagination = function (goToPage) {
  // 1) Render new results
  ResultsView.render(model.getSearchResultsPage(goToPage));

  // 2) Render new pagination buttons
  PaginationView.render(model.state.search);
};

const controlServings = function (newServings) {
  //Update the recipe servings(in state)
  model.updateServings(newServings);

  //Update the recipe view
  // RecipeView.render(model.state.recipe);
  RecipeView.update(model.state.recipe);
};

const controlAddBookmar = function () {
  //1) Add or remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  //2) Update recipe view 
  RecipeView.update(model.state.recipe);

  //3) Render bookmarks
  BookmarksView.render(model.state.bookmarks);
};

const conrtollerBookmark = function () {
  BookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    //show loading spinner
    AddRecipeView.renderSpinner();

    //upload new recipe data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //Render recipe
    RecipeView.render(model.state.recipe);

    //success message
    AddRecipeView.renderMessage();

    //Render bookmark view
    BookmarksView.render(model.state.bookmarks);

    //change id in url
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //close form window
    setTimeout(function () {
      AddRecipeView.toggleWindow()
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(`🚫`, err);
    AddRecipeView.renderError(err.message);
  };
}

const init = function () {
  BookmarksView.addHnadlerRender(conrtollerBookmark);
  RecipeView.addHandlerRender(controlRecipe);
  RecipeView.addHandlerUpdateServings(controlServings);
  RecipeView.addHandlerBookmark(controlAddBookmar);
  SearchView.addHandlerSearch(controlSearchResult);
  PaginationView.addHandlerClick(controlPagination);
  AddRecipeView.addHandlerUpload(controlAddRecipe);
};
init();